import * as React from 'react';
import { actionCreators } from '../../store/Controls/SMPACHeaderStore';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ScriptTag from 'react-script-tag';
import '../../css/SMPAC/pac_style.css';
import '../../css/SMPAC/jquery-ui.css';
import '../../css/SMPAC/panel.css';
import { toFormattedDatetime } from '../../tools/toolkit';

class SMPACHeader extends React.Component {

    componentWillMount() {
        this.props.getHtmlContent(this.props.programmeId, this.props.action, this.props.formListPageNumber);
    }

    getHeader() {
        return { __html: (this.props.isLoading ? '' : this.props.innerHtml) };
    }

    render() {
        return (
            <div>
                <ScriptTag isHydrating={true} type="text/javascript" src={"/js/jquerySVM.js?v=" + toFormattedDatetime(new Date())} />
                <ScriptTag isHydrating={true} type="text/javascript" src={"/js/pacHeader.js?v=" + toFormattedDatetime(new Date())} />
                <ScriptTag isHydrating={true} type="text/javascript" src={"/js/privacyPolicy.js?v=" + toFormattedDatetime(new Date())} />
                <ScriptTag isHydrating={true} type="text/javascript" src={"/SMPAC/js/moment.min.js?v=" + toFormattedDatetime(new Date())} />
                <ScriptTag isHydrating={true} type="text/javascript" src={"/SMPAC/js/PACCommon.js?v=" + toFormattedDatetime(new Date())} />
                <div dangerouslySetInnerHTML={this.getHeader()} />
            </div>
        );
    }



}

export default connect(
    state => state.smpacHeader,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(SMPACHeader);


// WEBPACK FOOTER //
// ./src/components/Controls/SMPACHeader.js